module.exports = __webpack_public_path__ + "static/media/vf_wskirt_core.018ee4a3.svg";